import { Stack } from "@mui/material";
import OneTimeProducts from "../PatientDashboard/components/OneTimeProducts";
import PrescriptionNotice from "../PatientDashboard/components/PrescriptionNotice";
import RecommendedDosageProvider from "src/context/RecommendedDosageProvider";
import OTRefillModal from "src/shared/components/OTRefillModal";
import LatestOrderProvider from "src/context/LatestOrder";

const Glp1s = () => {
  return (
    <Stack gap={2}>
      <PrescriptionNotice />
      <LatestOrderProvider>
        <RecommendedDosageProvider>
          <OneTimeProducts />
        </RecommendedDosageProvider>
      </LatestOrderProvider>
      <OTRefillModal />
    </Stack>
  );
};

export default Glp1s;
